<template>
  <div>
    <va-modal
      class="modal"
      v-model="showEdition"
      :okText="saveMessage"
      cancelText="Annuler"
      max-width="100%"
      v-on:ok="closeModal"
      v-on:cancel="closeModal"
      noEscDismiss
      noOutsideDismiss
      disabled
    >
      <div class="forcewidth">
        <div
          v-if="publication.date_cloture"
          class="row row-inside bandeau-activity"
          :style="{
            'background-color': this.$themes.danger,
          }"
        >
          <div class="flex md12 flex-center">
            <h3 class="warning-text flex-center">
              Publication cloturée le {{ publication.date_cloture }}
            </h3>
          </div>
        </div>
        <div
          class="row row-inside bandeau-spacer"
          v-if="publication.date_cloture"
        ></div>
        <div class="row row-inside">
          <div class="flex md8">
            <div class="row row-inside">
              <div class="flex md1">
                <div
                  class="numeroDisp-mod"
                  :style="{ backgroundColor: backgroundColor() }"
                >
                  <div
                    class="nb-pub"
                    v-if="!publication.hors_serie"
                  >
                    {{ publication.numero }}
                  </div>
                  <div
                    class="hs-pub"
                    v-else
                  >HORS-SERIE</div>
                  <div class="dp-pub">
                    {{
                      moment(
                        publication.date_previsionnelle,
                        "YYYY-MM-DD"
                      ).format("DD-MM-YYYY")
                    }}
                  </div>
                </div>
              </div>
              <div class="flex md1">
                <va-popover
                  class="popover"
                  message="Editer"
                  placement="left"
                >
                  <va-button
                    v-if="this.$store.getters.user.publications_numeros"
                    flat
                    icon="fa fa-edit"
                    :color="backgroundColor()"
                    class="action-button"
                    @click="openEditor()"
                  />
                </va-popover>
                <va-button
                  flat
                  icon="fa fa-briefcase"
                  :color="backgroundColor()"
                  class="action-button"
                  @click="openAnnonces()"
                />
              </div>

              <div class="flex md3 pa-1">
                <div class="date-pub">
                  Parution :
                  <span
                    class="centered-span"
                    v-if="publication.date_parution"
                  >
                    {{
                      moment(publication.date_parution, "YYYY-MM-DD").format(
                        "DD-MM-YYYY"
                      )
                    }}
                  </span>
                  <span
                    class="centered-span"
                    v-else
                  >-</span>
                </div>
              </div>
              <div class="flex md3 pa-1">
                <div class="date-pub">
                  Routage :
                  <span
                    class="centered-span"
                    v-if="publication.date_routage"
                  >
                    {{
                      moment(publication.date_routage, "YYYY-MM-DD").format(
                        "DD-MM-YYYY"
                      )
                    }}
                  </span>
                  <span
                    class="centered-span"
                    v-else
                  >-</span>
                </div>
              </div>
              <div class="flex md3 pa-1">
                <div class="date-pub">
                  Réception :
                  <span
                    class="centered-span"
                    v-if="publication.date_reception"
                  >
                    {{
                      moment(publication.date_reception, "YYYY-MM-DD").format(
                        "DD-MM-YYYY"
                      )
                    }}
                  </span>
                  <span
                    class="centered-span"
                    v-else
                  >-</span>
                </div>
              </div>
            </div>

            <div class="row row-inside mt-5">
              <div class="flex md6">
                <div class="flex md12">
                  <h4 class="cost-title">Coût du numéro</h4>
                </div>
                <div class="flex md12 ma-2">
                  <div class="date-pub">
                    <div class="row row-inside">
                      <div class="flex md6">Routage :</div>
                      <div
                        class="flex md6"
                        v-if="publication.cout_routage"
                      >
                        <span class="centered-span">
                          {{ publication.cout_routage }} €
                        </span>
                      </div>
                      <div
                        class="flex md1"
                        v-else
                      >
                        <span class="centered-span">- €</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="flex md12 ma-2">
                  <div class="date-pub">
                    <div class="row row-inside">
                      <div class="flex md6">Impression :</div>
                      <div
                        class="flex md6"
                        v-if="publication.cout_impression"
                      >
                        <span class="centered-span">
                          {{ publication.cout_impression }} €
                        </span>
                      </div>
                      <div
                        class="flex md1"
                        v-else
                      >
                        <span class="centered-span">- €</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="flex md12 ma-2">
                  <div class="date-pub">
                    <div class="row row-inside">
                      <div class="flex md6">Rédaction / conception :</div>
                      <div
                        class="flex md6"
                        v-if="publication.cout_conception"
                      >
                        <span class="centered-span">
                          {{ publication.cout_conception }} €
                        </span>
                      </div>
                      <div
                        class="flex md1"
                        v-else
                      >
                        <span class="centered-span">- €</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="flex md12 mt-5">
                  <h4 class="product-title">Produit du numéro</h4>
                </div>
                <div class="flex md12 ma-2">
                  <div class="date-pub">
                    <div class="row row-inside">
                      <div class="flex md6">Prévisionnel:</div>
                      <div
                        class="flex md6"
                        v-if="false"
                      >
                        <span class="centered-span"> {{}} € </span>
                      </div>
                      <div
                        class="flex md1"
                        v-else
                      >
                        <span class="centered-span">- €</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="flex md12 ma-2">
                  <div class="date-pub">
                    <div class="row row-inside">
                      <div class="flex md6">Effectif:</div>
                      <div
                        class="flex md6"
                        v-if="false"
                      >
                        <span class="centered-span"> {{}} € </span>
                      </div>
                      <div
                        class="flex md1"
                        v-else
                      >
                        <span class="centered-span">- €</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex md5 offset--md1">
                <div class="flex md12">
                  <h4 class="cost-title">Résultat du numéro</h4>
                </div>
                <div class="flex md12 ma-2">
                  <div class="date-pub">
                    <div class="row row-inside">
                      <div class="flex md6">Prévisionnel:</div>
                      <div
                        class="flex md6"
                        v-if="false"
                      >
                        <span class="centered-span"> {{}} € </span>
                      </div>
                      <div
                        class="flex md1"
                        v-else
                      >
                        <span class="centered-span">- €</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="flex md12 ma-2">
                  <div class="date-pub">
                    <div class="row row-inside">
                      <div class="flex md6">Effectif:</div>
                      <div
                        class="flex md6"
                        v-if="false"
                      >
                        <span class="centered-span"> {{}} € </span>
                      </div>
                      <div
                        class="flex md1"
                        v-else
                      >
                        <span class="centered-span">- €</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="flex md12 mt-5">
                  <h4>Diffusion du numéro</h4>
                </div>
                <div class="flex md12 ma-2">
                  <div class="date-pub">
                    <div class="row row-inside">
                      <div class="flex md6">Entreprises:</div>
                      <div
                        class="flex md6"
                        v-if="false"
                      >
                        <span class="centered-span"> {{}} € </span>
                      </div>
                      <div
                        class="flex md1"
                        v-else
                      >
                        <span class="centered-span">- €</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="flex md12 ma-2">
                  <div class="date-pub">
                    <div class="row row-inside">
                      <div class="flex md6">Partenaires:</div>
                      <div
                        class="flex md6"
                        v-if="false"
                      >
                        <span class="centered-span"> {{}} € </span>
                      </div>
                      <div
                        class="flex md1"
                        v-else
                      >
                        <span class="centered-span">- €</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="flex md12 ma-2">
                  <div class="button-listing">
                    <div class="row row-inside">
                      <div class="flex md6 centered-span">
                        Accès au listing d'envoi:
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="flex md4"></div>
        </div>
      </div>
    </va-modal>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { cloneDeep, find, isEqual } from "lodash";

export default {
  name: "visualisation-publication",
  props: ["value", "idnumero"],
  data() {
    return {
      moment: moment,
      showEdition: false,
      publication: this.resetPublication(),
      publication_bak: this.resetPublication(),
    };
  },
  mounted() {
    this.resetValues();
    this.showEdition = this.value; // initialize internal variables
  },
  methods: {
    openEditor() {
      //todo proper access controle
      if (!this.$store.getters.user.publications_numeros) {
        return;
      }
      this.$router.push({
        name: "liste-publication",
        params: { idnumero: this.publication.idpublication, edition: "edit" },
      });
    },
    openAnnonces() {
      this.$router.push({
        name: "annonces",
        params: { idnumero: this.publication.idpublication },
      });
    },
    resetPublication() {
      return {
        idpublication: null,
        numero: null,
        date_creation: moment().format("YYYY-MM-DD"),
        date_parution: null,
        date_routage: null,
        date_reception: null,
        date_cloture: null,
        date_ouverture: null,
        cout_routage: null,
        cout_impression: null,
        produit_previsionnel_final: null,
        produit_effectif: null,
        cout_conception: null,
        diffusion_partenaires: null,
        diffusion_entreprises: null,
        listing: false,
        pdf: false,
        date_previsionnelle: moment().format("DD-MM-YYYY"),
        hors_serie: false,
        isactif: false,
      };
    },
    resetValues() {
      //reset all values
      this.publication = this.resetPublication();
    },
    async loadPublication() {
      try {
        if (!this.idnumero) {
          //erreur pas de numéro selectionné
          this.launchEpicmaxToast("Aucune publication séléctionnée");
          this.$emit("close", false);
          this.$emit("input", false);
          return;
        }

        let resTmp = await axios.get("api/publications/publication", {
          params: { idpublication: this.idnumero },
        });

        this.publication = cloneDeep(resTmp.data);
      } catch (error) {
        console.log(error);
        this.launchEpicmaxToast("Erreur lors du chargement de la publication");
      }
    },

    closeModal() {
      this.resetValues();
      this.$emit("close", false);
      this.$emit("input", false);
    },
    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000,
      });
    },
    backgroundColor() {
      if (this.publication.isactif) {
        return "#4ae387";
      } else if (this.publication.date_cloture) {
        return "#ccc";
      } else {
        return "#4ab2e3";
      }
    },
  },
  computed: {
    saveMessage: function () {
      return "Fermer";
    },
  },
  watch: {
    value() {
      // Parent property changed; update internal variables
      this.showEdition = this.value;
      this.resetValues();
      if (this.value) {
        this.loadPublication();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.popover {
  z-index: 1500;
}
.forcewidth {
  width: 85vw;
  height: 60vh;
  overflow: auto;
}
.fullwidth {
  width: 95%;
}

.input-t1 {
  margin: 5px;
}
.numeroDisp-mod {
  min-height: 4em;
  span {
    outline: none !important;
  }
}
.nb-pub {
  padding: 0;
  margin: 0;
  color: white;
  font-weight: bold;
  font-size: 2em;
  text-align: center;
}
.dp-pub {
  padding: 0;
  margin: 0;
  color: white;
  text-align: center;
}

.hs-pub {
  padding: 0;
  margin: 0;
  padding-top: 1em;
  color: white;
  font-weight: bold;
  font-size: 1em;
  text-align: center;
}

.date-pub {
  display: flex;
  background-color: #ccc;
  width: 100%;
  height: 50%;
  padding: 10px;
  border-radius: 10px;
  align-items: center;
  color: rgb(110, 110, 110);
  font-weight: bold;
  font-size: 1.2em;
}

.button-listing {
  display: flex;
  background-color: rgb(156, 156, 156);
  width: 100%;
  height: 50%;
  padding: 10px;
  border-radius: 10px;
  align-items: center;
  color: rgb(80, 80, 80);
  font-weight: bold;
  font-size: 1.2em;
}

.button-listing:hover {
  background-color: #ccc;
  color: rgb(110, 110, 110);
  cursor: not-allowed;
}

.centered-span {
  margin: 0 auto;
}

.placeholder-span {
  margin-right: 5px;
}

.cost-title {
  color: #ff6961;
}

.product-title {
  color: #77dd77;
}

.action-button {
  padding: 0;
  margin-right: 15px;
}

.bandeau-activity {
  position: absolute;
  top: 0;
  left: 0;
  margin: 0;
  width: 100%;
  border-top-left-radius: 0.375rem;
  border-top-right-radius: 0.375rem;
  padding: 1.25rem 1.875rem 1.5rem 1.5rem;
}

.bandeau-spacer {
  top: 0;
  left: 0;
  margin: 0;
  width: 100%;
  border-top-left-radius: 0.375rem;
  border-top-right-radius: 0.375rem;
  padding: 2rem;
}

.warning-text {
  color: white;
  font-size: 1.2rem;
}
</style>
